export default __webpack_public_path__ + "static/titilliumweb-regular-webfont-e06eb147f34478f6aade058501d1d3ba.woff2";